import { afterGet as globalAfterGet } from "services/sosInventoryService/afterGet";
import {
  FIELDS_TO_TRANSFORM,
  QUICK_LIST_FIELDS_TO_TRANSFORM,
} from "services/sosInventoryService/vendor/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record) {
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM);
  return globalAfterGet(newRecord);
}

export function quickListAfterGet(record) {
  return transformFields(record, QUICK_LIST_FIELDS_TO_TRANSFORM);
}
